export default __webpack_public_path__ + "static/3-4dfb179afa594134a4f547dd8c3a8a94.webp";